/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/unbound-method */
import { Component, Inject, PLATFORM_ID, type OnInit } from '@angular/core';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { FormBuilder, type FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { type PaymentMethod } from '../../../shared/models/payment-method';
import { StorageEnum } from '../../../shared/enums/storage.enum';
import { catchError, concatMap, EMPTY, type Observable, of, throwError } from 'rxjs';

// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { StorageService } from '../../../shared/services/storage.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { PaymentService } from '../../../shared/services/payment.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { UtilService } from '../../../shared/services/util.service';
import { type AccountDetail } from '../../../shared/models/account-detail';
import { environment } from '../../../../environments/environment';
import { BankAccountFormComponent } from '../../../shared/components/bank-account-form/bank-account-form.component';
import { CreditCardFormComponent } from '../../../shared/components/credit-card-form/credit-card-form.component';
import { DialogResultType } from '../../../shared/enums/dialogresulttype.enum';
import { type PaymentAccountType } from '../../../shared/enums/paymentaccounttype.enum';
import { type PaymentDialogResult } from '../../../shared/models/payment-dialog-result';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { MatDialog } from '@angular/material/dialog';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { PaymentusService } from '../../../shared/services/paymentus.service';
import { DigitalPaymentModalComponent } from '../../../shared/components/digital-payment-modal/digital-payment-modal.component';
import { Capacitor } from '@capacitor/core';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { CmsService } from '../../../shared/services/cms.service';
import { format, isAfter, isEqual, toDate } from 'date-fns';
import { CTA, SuccessData, SuccessDetails } from '../../../shared/models/success-data.model';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { AutoPayChangeData } from '../../../shared/models/auto-pay-change';
import { type UserProfile } from '../../../shared/models/user-profile';
import { Nav } from '../../../shared/enums/nav.enum';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { ErrorService } from '../../../shared/services/error.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { NotificationsService } from '../../../shared/services/notifications.service';
import { NotificationType } from '../../../shared/enums/notificationtype.enum';
import { NotificationComponent } from '../../../shared/components/notification/notification.component';
import { EmailInfo } from '../../../shared/models/email-info';
import { emailValidator } from '../../../shared/validators/email.validator';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { AccountService } from '../../../shared/services/account.service';
import { EmailFormComponent } from '../../../shared/components/email-form/email-form.component';
import { PageHeaderComponent } from '../../../shared/components/page-header/page-header.component';
import { PageHeader } from '../../../shared/models/page-header.model';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { SeoService } from '../../../shared/services/seo.service';

@Component({
  selector: 'app-autopay-enroll',
  imports: [
    ReactiveFormsModule,
    MatSelectModule,
    MatFormFieldModule,
    MatButtonModule,
    MatCheckboxModule,
    NotificationComponent,
    EmailFormComponent,
    PageHeaderComponent,
  ],
  templateUrl: './autopay-enroll.component.html',
  styleUrl: './autopay-enroll.component.scss',
})
export class AutopayEnrollComponent implements OnInit {
  pageReady = false;
  isBrowser = false;
  accountDetail: AccountDetail;
  userProfile?: UserProfile;
  autopayForm: FormGroup;
  paymethods: PaymentMethod[] | undefined = [];
  formErrorMessage?: string = '';
  pageLabels: any;
  showFDPWillBeDraftedPreNotification = false;
  showFDPWillBeCanceledPreNotification = false;
  showLimitedPaymentOptionPreNotification = false;
  showBillDueTodayPreNotification = false;
  autoPayErrors: any[] = [];
  changeAutoPayData: AutoPayChangeData;
  changeAutoPay = false;
  emailFormData: any = {};
  hasEmail: boolean = false;
  disableDigitalPayments: boolean = false;
  headerData = new PageHeader();
  pageName = Nav.AutopayEnroll;

  constructor(
    // eslint-disable-next-line @typescript-eslint/ban-types
    @Inject(PLATFORM_ID) readonly platformId: Object,
    private readonly cms: CmsService,
    public dialog: MatDialog,
    private readonly fb: FormBuilder,
    private readonly payment: PaymentService,
    private readonly paymentus: PaymentusService,
    private readonly router: Router,
    private readonly storage: StorageService,
    private readonly utils: UtilService,
    private readonly error: ErrorService,
    private readonly notification: NotificationsService,
    private readonly account: AccountService,
    private readonly seoS: SeoService,
    private readonly notifi: NotificationsService,
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
    this.accountDetail = this.storage.getSession(StorageEnum.AccountDetail);
    this.userProfile = this.storage.getSession(StorageEnum.LoginResponse);
    this.autopayForm = this.fb.group({
      paymethod: this.fb.control<PaymentMethod | null>(null, [Validators.required]),
      terms: this.fb.control<boolean>(false, [Validators.requiredTrue]),
    });
    this.autoPayErrors = this.storage.getSession(StorageEnum.GlobalVars)?.autoPayErrors;
    this.changeAutoPayData = this.storage.getSession(StorageEnum.ChangeAutoPayData);
    this.disableDigitalPayments = this.storage.getSession(StorageEnum.GlobalVars)?.disableDigitalPayments;
  }

  ngOnInit(): void {
    if (this.router.url.includes(Nav.AutopayEnroll) && this.accountDetail.IsAutoPay) {
      void this.router.navigateByUrl(Nav.AccountSummary);
    }
    this.cms
      .getContent('autopay-enroll', 'Autopay Enroll')
      .pipe(
        concatMap((data) => {
          this.pageLabels = data;
          this.headerData.Message = this.pageLabels.header;
          this.seoS.setSeoTags(data.seo);

          if (this.isBrowser) {
            this.displayPreNotifications();
            this.checkForAutoPayChange();
            return this.payment.getPreferredPayments(this.accountDetail);
          } else {
            return EMPTY;
          }
        }),
      )
      .subscribe((data: any) => {
        if (!data.PaymentMethods) {
          data.PaymentMethods = [];
        }
        this.storage.setSession(StorageEnum.PaymentMethods, data.PaymentMethods);
        this.payment.addNewCardAndBankToPaymethodList(
          data.PaymentMethods,
          this.pageLabels.paymentMethodNewBankText,
          this.pageLabels.paymentMethodNewCardText,
        );
        this.paymethods = this.payment.sortPaymentMethods(
          data.PaymentMethods,
          this.disableDigitalPayments,
          this.accountDetail.IsLimitedPaymentOptions,
        );
        this.hasEmail =
          this.accountDetail?.Person?.EmailAddresses?.find((email: EmailInfo) => {
            return email.IsPrimary && email.Type?.toUpperCase() === 'EMAIL';
          })?.IsPrimary ?? false;
        if (!this.hasEmail) {
          this.setupEmailData();
        }
        this.utils.hideSpinner();
        this.pageReady = true;
      });
  }

  displayPreNotifications(): void {
    const todaysDate = format(new Date().toString(), 'MM/dd/yyyy');
    const billDueDate = format(toDate(this.accountDetail.CurrentBalanceDueDate!).toString(), 'MM/dd/yyyy');

    if (this.accountDetail.FuturePayment?.Info?.PaymentDate && this.accountDetail.FuturePayment?.Info?.PaymentAmount) {
      const futurePaymentDate = format(
        toDate(this.accountDetail.FuturePayment.Info.PaymentDate).toString(),
        'MM/dd/yyyy',
      );
      const futurePaymentAmount = this.accountDetail.FuturePayment.Info?.PaymentAmount;
      if (futurePaymentDate < billDueDate) {
        this.pageLabels.fdpWillBeDraftedPreNofitication = this.pageLabels.fdpWillBeDraftedPreNofitication.replace(
          '{{date}}',
          futurePaymentDate,
        );
        this.pageLabels.fdpWillBeDraftedPreNofitication = this.pageLabels.fdpWillBeDraftedPreNofitication.replace(
          '{{$}}',
          '$' + futurePaymentAmount,
        );
        this.notification.addNotification(
          this.pageLabels.fdpWillBeDraftedPreNofitication,
          NotificationType.Prenotification,
          this.pageName,
        );
      } else if (futurePaymentDate >= billDueDate) {
        this.showFDPWillBeCanceledPreNotification = true;
        this.pageLabels.fdpWillBeCanceledPreNofitication = this.pageLabels.fdpWillBeCanceledPreNofitication.replace(
          '{{date}}',
          futurePaymentDate,
        );
        this.notification.addNotification(
          this.pageLabels.fdpWillBeCanceledPreNofitication,
          NotificationType.Prenotification,
          this.pageName,
        );
      }
    }
    if (this.accountDetail.IsLimitedPaymentOptions) {
      this.notification.addNotification(
        this.pageLabels.limitedPaymentPreNotification,
        NotificationType.Alert,
        this.pageName,
      );
    }
    if (billDueDate === todaysDate) {
      this.notification.addNotification(
        this.pageLabels.billDueTodayPreNofitication,
        NotificationType.Prenotification,
        this.pageName,
      );
    }
  }

  checkForAutoPayChange(): void {
    if (this.router.url.includes('autopay-change')) {
      this.changeAutoPay = true;
      this.pageLabels.changeAutoPayEnrollText = this.pageLabels.changeAutoPayEnrollText.replace(
        '{{paymethod}}',
        this.changeAutoPayData.PaymentAccountType,
      );
      if (this.changeAutoPayData.PaymentType === 'DIGITAL') {
        this.pageLabels.changeAutoPayEnrollText = this.pageLabels.changeAutoPayEnrollText.replace(
          '{{endingnumber}}',
          '',
        );
      } else {
        this.pageLabels.changeAutoPayEnrollText = this.pageLabels.changeAutoPayEnrollText.replace(
          '{{endingnumber}}',
          ' ending in ' + this.changeAutoPayData.LastFour,
        );
      }
    }
  }

  paymethodChanged(): void {
    const selectedPaymethod: PaymentMethod = this.autopayForm.get('paymethod')?.value;
    const selectedPaymethodType = this.payment.isCardBankDigital(selectedPaymethod.PaymentAccountType);
    if (selectedPaymethodType === 'BANK') {
      if (!selectedPaymethod.ReferenceId) {
        this.openBankAccountForm();
      }
    } else if (selectedPaymethodType === 'DIGITAL') {
      if (!selectedPaymethod.ReferenceId) {
        this.openDigitalPayment(selectedPaymethod.PaymentAccountType!);
      }
    } else if (selectedPaymethodType === 'CARD') {
      this.openCreditCardForm();
    } else if (selectedPaymethodType === 'CASH') {
      this.utils.consoleLog('cash money');
    } else {
      this.utils.consoleLog(`selectedPaymethodType: ${selectedPaymethodType}`);
    }
  }

  openCreditCardForm(): void {
    const dialogRef = this.dialog.open(CreditCardFormComponent, {
      ariaLabel: 'Credit Card',
      disableClose: true,
      autoFocus: 'first-heading',
      panelClass: 'gs-dialog',
      data: { payMethod: this.autopayForm.get('paymethod')?.value, parentForm: 'autopay' },
    });

    dialogRef.afterClosed().subscribe((result: PaymentDialogResult) => {
      this.utils.showSpinner();
      if (result.Type === DialogResultType.Cancel) {
        this.autopayForm.patchValue({ paymethod: null });
        this.utils.hideSpinner();
      } else if (result.Type === DialogResultType.Update) {
        // Find Record in the List and Update it
        this.paymethods = this.paymethods?.map((pm) =>
          pm.ReferenceId === result.PayMethod.ReferenceId ? result.PayMethod : pm,
        );
        // select Update record
        if (!this.utils.isNullOrWhitespace(result.PayMethod.ReferenceId)) {
          const newSelectedMethod = this.paymethods?.find((pm) => {
            return pm.ReferenceId === result.PayMethod.ReferenceId;
          });
          this.autopayForm.patchValue({ paymethod: newSelectedMethod });
        }
      } else if (result.Type === DialogResultType.Add) {
        this.payment.addNewPayMethod(this.paymethods!, result.PayMethod);
        this.paymethods = this.payment.sortPaymentMethods(
          this.paymethods!,
          this.disableDigitalPayments,
          this.accountDetail.IsLimitedPaymentOptions,
        );
        if (!this.utils.isNullOrWhitespace(result.PayMethod.ReferenceId)) {
          const newSelectedMethod = this.paymethods.find((pm) => {
            return pm.ReferenceId === result.PayMethod.ReferenceId;
          });
          this.autopayForm.patchValue({ paymethod: newSelectedMethod });
        }
      } else if (result.Type === DialogResultType.Error) {
        this.autopayForm.patchValue({ paymethod: null });
        this.showFormErrorLabel(result.ErrorMessage);
        this.utils.hideSpinner();
      }
      this.storage.setSession(StorageEnum.PaymentMethods, this.paymethods);
      this.utils.hideSpinner();
    });
  }

  openBankAccountForm(): void {
    const dialogRef = this.dialog.open(BankAccountFormComponent, {
      ariaLabel: 'Bank Account',
      disableClose: true,
      autoFocus: 'first-heading',
      panelClass: 'gs-dialog',
      data: 'autopay',
    });

    dialogRef.afterClosed().subscribe((result: PaymentDialogResult) => {
      if (result.Type === DialogResultType.Cancel) {
        this.autopayForm.patchValue({ paymethod: null });
        this.utils.hideSpinner();
      } else if (result.Type === DialogResultType.Add) {
        this.payment.addNewPayMethod(this.paymethods!, result.PayMethod);
        this.paymethods = this.payment.sortPaymentMethods(
          this.paymethods!,
          this.disableDigitalPayments,
          this.accountDetail.IsLimitedPaymentOptions,
        );
        this.storage.setSession(StorageEnum.PaymentMethods, this.paymethods);
        if (!this.utils.isNullOrWhitespace(result.PayMethod.ReferenceId)) {
          const newSelectedMethod = this.paymethods.find((pm) => {
            return pm.ReferenceId === result.PayMethod.ReferenceId;
          });
          this.autopayForm.patchValue({ paymethod: newSelectedMethod });
        }
      } else if (result.Type === DialogResultType.Error) {
        this.autopayForm.patchValue({ paymethod: null });
        this.showFormErrorLabel(result.ErrorMessage);
        this.utils.hideSpinner();
      }
      this.utils.hideSpinner();
    });
  }

  openDigitalPayment(paymentType: PaymentAccountType): void {
    const page = window.location.origin + '/autopay-enroll';
    // Detect platform for mobile redirect flow
    const platform = Capacitor.isNativePlatform() ? (Capacitor.getPlatform() as 'ios' | 'android') : undefined;
    this.paymentus
      .getDigitalPaymentToken(this.accountDetail?.AccountNumber, paymentType, page, platform)
      .pipe(
        catchError((dataError: any) => {
          void this.router.navigateByUrl(Nav.ErrorPage);
          return throwError(() => new Error(dataError));
        }),
        concatMap((data: string) => {
          const url = environment.paymentusDigitalTokenUrl() + '?authToken=' + data;
          return this.createIframe(url, page, paymentType);
        }),
      )
      .subscribe((result: PaymentDialogResult) => {
        if (result.Type === DialogResultType.Add) {
          this.paymethods?.push(result.PayMethod);
          this.paymethods = this.payment.sortPaymentMethods(
            this.paymethods!,
            this.disableDigitalPayments,
            this.accountDetail.IsLimitedPaymentOptions,
          );
          if (!this.utils.isNullOrWhitespace(result.PayMethod.ReferenceId)) {
            const newSelectedMethod = this.paymethods.find((pm) => {
              return pm.ReferenceId === result.PayMethod.ReferenceId;
            });
            this.autopayForm.patchValue({ paymethod: newSelectedMethod });
          }
        } else if (result.Type === DialogResultType.Cancel) {
          this.autopayForm.patchValue({ paymethod: null });
          this.utils.hideSpinner();
        }
        this.utils.hideSpinner();
      });
  }

  createIframe(url: string, page: string, paymentAccountType: PaymentAccountType): Observable<any> {
    const dialogRef = this.dialog.open(DigitalPaymentModalComponent, {
      ariaLabel: paymentAccountType.toString(),
      disableClose: true,
      autoFocus: 'first-heading',
      panelClass: 'gs-dialog',
      data: {
        url,
        page,
        paymentAccountType,
        callbackUrlPattern: environment.digitalPaymentCallbackPath,
      },
      height: '500px',
      width: '500px',
    });

    return dialogRef.afterClosed();
  }

  showFormErrorLabel(errorMessage?: string): void {
    this.formErrorMessage = errorMessage;
    if (this.formErrorMessage && this.formErrorMessage !== '') {
      this.notifi.clearAllNotifications(this.pageName);
      this.notifi.addNotification(this.formErrorMessage, NotificationType.Error, this.pageName);
    }
  }

  enrollAutopay(): void {
    this.formErrorMessage = '';
    this.autopayForm.markAllAsTouched();
    this.utils.showSpinner();

    const todaysDate = format(new Date(), 'MM/dd/yyyy');
    const billDueDate = this.accountDetail.CurrentBalanceDueDate!;
    const paymentDate = this.accountDetail.FuturePayment?.Info?.PaymentDate;

    format(billDueDate, 'MM/dd/yyyy');
    format(todaysDate, 'MM/dd/yyyy');

    if (!this.hasEmail) {
      // handle new email stuff
      // according to ticket, even if this call fails we continue with payment, so we don't really need to do anything with the response
      if (this.emailFormData.formGroup.valid) {
        const emailValue = this.emailFormData.formGroup.value.email;

        const personRequest = this.accountDetail?.Person;
        const email = new EmailInfo();
        email.ContactId = '';
        email.Email = emailValue;
        email.IsActive = true;
        email.IsPrimary = true;
        email.Type = 'EMAIL';
        personRequest?.EmailAddresses?.push(email);
        this.account.UpdatePersonContact(personRequest).subscribe({
          error: (e) => {
            this.utils.consoleLog('There was an error adding email on payments page. Error: ' + e);
          },
          next: (data: any) => {
            this.accountDetail.Person = data;
            this.storage.setSession(StorageEnum.AccountDetail, this.accountDetail);
            this.hasEmail = true;
          },
        });
      } else {
        const errorMessage = this.storage.getSession(StorageEnum.GlobalVars).formError;
        this.emailFormData.formGroup.markAllAsTouched();
        this.showFormErrorLabel(errorMessage);
        this.utils.hideSpinner();
        return;
      }
    }

    if (this.autopayForm.valid) {
      const selectedPayMethod: PaymentMethod = this.autopayForm.get('paymethod')?.value;

      // submit form
      const data = {
        AccountNumber: this.accountDetail.AccountNumber,
        CustomerClass: this.accountDetail.CustomerClass,
        FirstName: this.accountDetail.FirstName,
        LastName: this.accountDetail.LastName,
        Email: this.accountDetail.Email,
        payMethod: selectedPayMethod,
      };

      data.payMethod.AccountNumber = this.accountDetail.AccountNumber;
      data.payMethod.UserName = this.userProfile?.UserName;

      const builderSuccess = this.pageLabels.enrollSuccessData.value.data;
      const successData = new SuccessData();

      this.payment
        .enrollAutoPay(data)
        .pipe(
          catchError((e) => {
            this.setErrorData(e.message);
            void this.router.navigateByUrl(Nav.ErrorPage);
            return EMPTY;
          }),
          concatMap((data: any) => {
            this.accountDetail.AutoPay = data;
            this.accountDetail.IsAutoPay = true;
            successData.Header = builderSuccess.header;
            successData.DetailPreMessage = builderSuccess.detailPreMessage;
            successData.DetailPostMessage = builderSuccess.detailPostMessage;
            if (this.accountDetail.FuturePayment) {
              // If a future dated payment is scheduled and the draft date is = or > current bill due date. Cancel the future dated payment.
              const futurePaymentDate = toDate(paymentDate!).getTime();
              if (isAfter(futurePaymentDate, billDueDate) || isEqual(futurePaymentDate, billDueDate)) {
                const futurePayment = this.payment.buildCancelFutureDatePaymentRequest(this.accountDetail);

                return this.payment.postFuturePayment(futurePayment).pipe(
                  catchError((e) => {
                    // USER STORY 86028
                    const builderSuccess = this.pageLabels.enrollSuccessFdpErrorData.value.data;
                    const successData = new SuccessData();
                    successData.Header = builderSuccess.header;
                    const cancelFdpFailedNotification = builderSuccess.postNotificationList.find((message: any) => {
                      return message.messageId === 'cancelScheduledPaymentFailed';
                    });
                    successData.PostNotificationList.push({
                      Message: cancelFdpFailedNotification.message,
                      NotificationType: NotificationType.Alert,
                    });
                    const cta = new CTA();
                    const autoPayCTA = builderSuccess.ctaList.find((cta: any) => {
                      return cta.ctaId === 'cancelScheduledPayment';
                    });
                    cta.Label = autoPayCTA.ctaLabel;
                    cta.AriaLabel = autoPayCTA.ctaAriaLabel;
                    cta.Link = autoPayCTA.ctaUrl;
                    successData.CTAList.push(cta);
                    this.storage.setSession(StorageEnum.SuccessData, successData);
                    void this.router.navigateByUrl(Nav.AutopayEnrollSuccess);
                    return EMPTY;
                  }),
                );
              }
              return of('FDPBeforeBillDue');
            } else {
              this.storage.setSession(StorageEnum.AccountDetail, this.accountDetail);

              const detail = new SuccessDetails();
              detail.Label = builderSuccess.details[0].detailLabel;
              detail.Value = this.getEnrollSuccessDescription();
              successData.Details.push(detail);

              const cta = new CTA();
              let autoPayCTA;

              if (isEqual(todaysDate, billDueDate)) {
                autoPayCTA = builderSuccess.ctaList.find((cta: any) => {
                  return cta.ctaId === 'payment';
                });
                cta.Label = autoPayCTA.ctaLabel;
                cta.AriaLabel = autoPayCTA.ctaAriaLabel;
                cta.Link = autoPayCTA.ctaUrl;
                successData.CTAList.push(cta);
                const billDuePostNotification = builderSuccess.postNotificationList.find((message: any) => {
                  return message.messageId === 'billtoday';
                });
                successData.PostNotificationList.push({
                  Message: billDuePostNotification.message,
                  NotificationType: NotificationType.Alert,
                });
              } else if (this.accountDetail.PastDueBalance! > 0) {
                const pastDueNotification = builderSuccess.postNotificationList.find((message: any) => {
                  return message.messageId === 'pastdue';
                });
                successData.PostNotificationList.push({
                  Message: pastDueNotification.message,
                  NotificationType: NotificationType.Alert,
                });
                autoPayCTA = builderSuccess.ctaList.find((cta: any) => {
                  return cta.ctaId === 'payment';
                });
                cta.Label = autoPayCTA.ctaLabel;
                cta.AriaLabel = autoPayCTA.ctaAriaLabel;
                cta.Link = autoPayCTA.ctaUrl;
                successData.CTAList.push(cta);
              } else {
                autoPayCTA = builderSuccess.ctaList.find((cta: any) => {
                  return cta.ctaId === 'accountsummary';
                });
                cta.Label = autoPayCTA.ctaLabel;
                cta.AriaLabel = autoPayCTA.ctaAriaLabel;
                cta.Link = autoPayCTA.ctaUrl;
                successData.CTAList.push(cta);
              }
              this.storage.setSession(StorageEnum.SuccessData, successData);
              void this.router.navigateByUrl(Nav.AutopayEnrollSuccess);
              return EMPTY;
            }
          }),
        )
        .subscribe((data: any) => {
          if (data !== 'FDPBeforeBillDue') {
            this.accountDetail.FuturePayment = null;
            this.storage.setSession(StorageEnum.AccountDetail, this.accountDetail);
            const fdrPostNotification = builderSuccess.postNotificationList.find((message: any) => {
              return message.messageId === 'fdpcancelled';
            });
            successData.PostNotificationList.push({
              Message: fdrPostNotification.message,
              NotificationType: NotificationType.Alert,
            });
          }

          const detail = new SuccessDetails();
          detail.Label = builderSuccess.details[0].detailLabel;
          detail.Value = this.getEnrollSuccessDescription();
          successData.Details.push(detail);

          const cta = new CTA();
          let autoPayCTA;

          if (isEqual(todaysDate, billDueDate)) {
            autoPayCTA = builderSuccess.ctaList.find((cta: any) => {
              return cta.ctaId === 'payment';
            });
            cta.Label = autoPayCTA.ctaLabel;
            cta.AriaLabel = autoPayCTA.ctaAriaLabel;
            cta.Link = autoPayCTA.ctaUrl;
            successData.CTAList.push(cta);
            const billDuePostNotification = builderSuccess.postNotificationList.find((message: any) => {
              return message.messageId === 'billtoday';
            });
            successData.PostNotificationList.push({
              Message: billDuePostNotification.message,
              NotificationType: NotificationType.Alert,
            });
          } else if (this.accountDetail.PastDueBalance! > 0) {
            const pastDueNotification = builderSuccess.postNotificationList.find((message: any) => {
              return message.messageId === 'pastdue';
            });
            successData.PostNotificationList.push({
              Message: pastDueNotification.message,
              NotificationType: NotificationType.Alert,
            });
            autoPayCTA = builderSuccess.ctaList.find((cta: any) => {
              return cta.ctaId === 'payment';
            });
            cta.Label = autoPayCTA.ctaLabel;
            cta.AriaLabel = autoPayCTA.ctaAriaLabel;
            cta.Link = autoPayCTA.ctaUrl;
            successData.CTAList.push(cta);
          } else {
            autoPayCTA = builderSuccess.ctaList.find((cta: any) => {
              return cta.ctaId === 'accountsummary';
            });
            cta.Label = autoPayCTA.ctaLabel;
            cta.AriaLabel = autoPayCTA.ctaAriaLabel;
            cta.Link = autoPayCTA.ctaUrl;
            successData.CTAList.push(cta);
          }
          this.storage.setSession(StorageEnum.SuccessData, successData);
          void this.router.navigateByUrl(Nav.AutopayEnrollSuccess);
        });
    } else {
      const errorMessage = this.storage.getSession(StorageEnum.GlobalVars).formError;
      this.showFormErrorLabel(errorMessage);
      this.utils.hideSpinner();
    }
  }

  getEnrollSuccessDescription(): string {
    const selectedPayMethod: PaymentMethod = this.autopayForm.get('paymethod')?.value;

    if (selectedPayMethod.Nickname) {
      if (selectedPayMethod.LastFour) {
        return selectedPayMethod.Nickname + ' ending in ' + selectedPayMethod.LastFour;
      } else {
        return selectedPayMethod.Nickname;
      }
    } else {
      return selectedPayMethod.Description!;
    }
  }

  setErrorData(errorCode: string): void {
    this.error.setErrorData(errorCode, this.pageLabels.enrollErrorData);
  }

  setupEmailData(): void {
    this.emailFormData.showConfirmEmail = true;
    this.emailFormData.formGroup = this.fb.group({
      email: ['', [Validators.required, emailValidator()]],
      emailConfirm: ['', [Validators.required, emailValidator()]],
    });
  }
}
